import TwoFactorConfirmation from './TwoFactorConfirmation';

export default TwoFactorConfirmation;
